import axios from "axios";
import { CASTTREE_BASE_URL } from "../helper/video-uploader.helper";
import { APP_CONSTANTS, ENV } from "../const/app.const";

const ENV_VARIABLES = APP_CONSTANTS[ENV];

const CASTTREE_SERVICE_BASE_URL = ENV_VARIABLES.CASTTREE_SERVICE_BASE_URL;

const LearnService = {
  getServiceItemList: async () => {
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/service-item/service-items`
    );
    return response.data;
  },
  getItemDetail: async (processId) => {
    const headers = {
      "x-userid": "68678196f748fddd2d3b778c",
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/process/${processId}/tasks`,
      { headers }
    );
    return response.data;
  },
  getPromotionalDetail: async () => {
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/service-item/promotion-details`
    );
    return response.data;
  },

  getPaymentRequest: async () => {
    const accessToken = await localStorage.getItem("access_token");
    const user_id = await localStorage.getItem("user_id");
    const headers = {
      Authorization: `Bearer ${accessToken}`,
      "Content-Type": "application/json",
    };
    const response = await axios.get(
      `${CASTTREE_SERVICE_BASE_URL}/casttree-oms/payment-request/user/${user_id}`,
      { headers }
    );
    return response.data;
  },
};

export default LearnService;